import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, toDisplayString as _toDisplayString, withModifiers as _withModifiers, renderList as _renderList, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives } from "vue";
const _hoisted_1 = { class: "form" };
const _hoisted_2 = { class: "clearfix" };
const _hoisted_3 = { class: "clearfix" };
const _hoisted_4 = { class: "d-flex flex-wrap gap-2" };
const _hoisted_5 = { key: 0 };
const _hoisted_6 = {
    key: 2,
    class: "d-flex",
    style: { "width": "800px" }
};
const _hoisted_7 = ["onClick"];
const _hoisted_8 = ["onClick"];
const _hoisted_9 = { class: "system-management-tree" };
const _hoisted_10 = { class: "component-tree component-tree-small" };
const _hoisted_11 = { class: "ms-2" };
const _hoisted_12 = { class: "fw-bold" };
const _hoisted_13 = {
    key: 0,
    class: "ms-1"
};
const _hoisted_14 = { key: 0 };
const _hoisted_15 = { key: 1 };
const _hoisted_16 = ["onClick"];
const _hoisted_17 = {
    key: 1,
    class: "ms-1"
};
const _hoisted_18 = { class: "clearfix" };
const _hoisted_19 = { class: "col-sm-12 col-xs-12 col-md-12 bottom10" };
const _hoisted_20 = ["onClick"];
const _hoisted_21 = { class: "col-sm-12 col-xs-12 col-md-12 bottom10" };
const _hoisted_22 = ["onClick"];
const _hoisted_23 = {
    key: 0,
    class: "col-sm-12 col-xs-12 col-md-12 bottom10"
};
const _hoisted_24 = {
    key: 1,
    class: "col-sm-12 col-xs-12 col-md-12 bottom10"
};
const _hoisted_25 = { class: "col-sm-12 col-xs-12 col-md-12 bottom10" };
const _hoisted_26 = { class: "checkbox-wrapper" };
const _hoisted_27 = { class: "float-end float-start-sm" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_b_button = _resolveComponent("b-button");
    const _component_flat_pickr = _resolveComponent("flat-pickr");
    const _component_b_input_group_append = _resolveComponent("b-input-group-append");
    const _component_b_input_group = _resolveComponent("b-input-group");
    const _component_multiselect = _resolveComponent("multiselect");
    const _component_ComponentTreeVue = _resolveComponent("ComponentTreeVue");
    const _component_b_form_input = _resolveComponent("b-form-input");
    const _component_b_form_checkbox = _resolveComponent("b-form-checkbox");
    const _component_b_container = _resolveComponent("b-container");
    const _component_b_modal = _resolveComponent("b-modal");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _withDirectives(_createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                    (!_ctx.isClient)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                            _createVNode(_component_b_button, {
                                class: "mb-0",
                                "variant-": "secondary",
                                disabled: !_ctx.hasStringSelection() || _ctx.settingValues(),
                                onClick: _ctx.setManufactorerAndModel
                            }, {
                                default: _withCtx(() => [...(_cache[12] || (_cache[12] = [
                                        _createElementVNode("i", {
                                            class: "fa fa-check",
                                            "aria-hidden": "true"
                                        }, null, -1 /* CACHED */),
                                        _createTextVNode(" Set Manufacturer and Model\r\n\t\t\t\t\t\t", -1 /* CACHED */)
                                    ]))]),
                                _: 1 /* STABLE */
                            }, 8 /* PROPS */, ["disabled", "onClick"]),
                            _cache[15] || (_cache[15] = _createTextVNode()),
                            _createVNode(_component_b_button, {
                                class: "mb-0",
                                "variant-": "secondary",
                                disabled: !_ctx.hasSelection() || _ctx.settingValues(),
                                onClick: _ctx.setManufactureDate
                            }, {
                                default: _withCtx(() => [...(_cache[13] || (_cache[13] = [
                                        _createElementVNode("i", {
                                            class: "fa fa-check",
                                            "aria-hidden": "true"
                                        }, null, -1 /* CACHED */),
                                        _createTextVNode(" Set Manufacture Date\r\n\t\t\t\t\t\t", -1 /* CACHED */)
                                    ]))]),
                                _: 1 /* STABLE */
                            }, 8 /* PROPS */, ["disabled", "onClick"]),
                            _cache[16] || (_cache[16] = _createTextVNode()),
                            _createVNode(_component_b_button, {
                                class: "mb-0",
                                "variant-": "secondary",
                                disabled: !_ctx.hasSelection() || _ctx.settingValues(),
                                onClick: _ctx.setReplacmentDate
                            }, {
                                default: _withCtx(() => [...(_cache[14] || (_cache[14] = [
                                        _createElementVNode("i", {
                                            class: "fa fa-exchange",
                                            "aria-hidden": "true"
                                        }, null, -1 /* CACHED */),
                                        _createTextVNode(" Set Replacement Date\r\n\t\t\t\t\t\t", -1 /* CACHED */)
                                    ]))]),
                                _: 1 /* STABLE */
                            }, 8 /* PROPS */, ["disabled", "onClick"])
                        ]))
                        : _createCommentVNode("v-if", true),
                    _cache[40] || (_cache[40] = _createTextVNode()),
                    (_ctx.settingValues())
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            (_ctx.settingManufacture)
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                    _cache[19] || (_cache[19] = _createElementVNode("label", { class: "ms-5 me-2 pt-2 mb-0" }, [
                                        _createElementVNode("span", null, "Manufactured on")
                                    ], -1 /* CACHED */)),
                                    _cache[20] || (_cache[20] = _createTextVNode()),
                                    _createVNode(_component_b_input_group, {
                                        style: { "width": "160px" },
                                        class: "clearfix bottom0 me-2"
                                    }, {
                                        default: _withCtx(() => [
                                            _createVNode(_component_flat_pickr, {
                                                modelValue: _ctx.manufactureDate,
                                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.manufactureDate) = $event)),
                                                class: "form-control",
                                                config: _ctx.datePickerConfig
                                            }, null, 8 /* PROPS */, ["modelValue", "config"]),
                                            _cache[18] || (_cache[18] = _createTextVNode()),
                                            _createVNode(_component_b_input_group_append, null, {
                                                default: _withCtx(() => [
                                                    _createVNode(_component_b_button, {
                                                        type: "button",
                                                        variant: "outline-secondary",
                                                        "data-toggle": ""
                                                    }, {
                                                        default: _withCtx(() => [...(_cache[17] || (_cache[17] = [
                                                                _createElementVNode("i", { class: "fa fa-calendar" }, null, -1 /* CACHED */)
                                                            ]))]),
                                                        _: 1 /* STABLE */
                                                    })
                                                ]),
                                                _: 1 /* STABLE */
                                            })
                                        ]),
                                        _: 1 /* STABLE */
                                    })
                                ], 64 /* STABLE_FRAGMENT */))
                                : _createCommentVNode("v-if", true),
                            _cache[37] || (_cache[37] = _createTextVNode()),
                            (_ctx.settingReplacement)
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                    _cache[23] || (_cache[23] = _createElementVNode("label", { class: "ms-2 me-2 pt-2 mb-0" }, [
                                        _createElementVNode("span", null, "Replaced on")
                                    ], -1 /* CACHED */)),
                                    _cache[24] || (_cache[24] = _createTextVNode()),
                                    _createVNode(_component_b_input_group, {
                                        style: { "width": "160px" },
                                        class: "clearfix bottom0 me-2"
                                    }, {
                                        default: _withCtx(() => [
                                            _createVNode(_component_flat_pickr, {
                                                modelValue: _ctx.replacementDate,
                                                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((_ctx.replacementDate) = $event)),
                                                class: "form-control",
                                                config: _ctx.datePickerConfig
                                            }, null, 8 /* PROPS */, ["modelValue", "config"]),
                                            _cache[22] || (_cache[22] = _createTextVNode()),
                                            _createVNode(_component_b_input_group_append, null, {
                                                default: _withCtx(() => [
                                                    _createVNode(_component_b_button, {
                                                        type: "button",
                                                        variant: "outline-secondary",
                                                        "data-toggle": ""
                                                    }, {
                                                        default: _withCtx(() => [...(_cache[21] || (_cache[21] = [
                                                                _createElementVNode("i", { class: "fa fa-calendar" }, null, -1 /* CACHED */)
                                                            ]))]),
                                                        _: 1 /* STABLE */
                                                    })
                                                ]),
                                                _: 1 /* STABLE */
                                            })
                                        ]),
                                        _: 1 /* STABLE */
                                    })
                                ], 64 /* STABLE_FRAGMENT */))
                                : _createCommentVNode("v-if", true),
                            _cache[38] || (_cache[38] = _createTextVNode()),
                            (_ctx.settingManufacturerAndModel)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                                    _createVNode(_component_multiselect, {
                                        name: "manufacturerId",
                                        modelValue: _ctx.manufacturer,
                                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((_ctx.manufacturer) = $event)),
                                        "track-by": "value",
                                        label: "text",
                                        placeholder: _ctx.selectPlaceholder,
                                        options: _ctx.batteryManufacturers,
                                        showLabels: false,
                                        allowEmpty: true,
                                        taggable: true,
                                        "tag-placeholder": "Press enter to add new manufacturer",
                                        onTag: _ctx.addStringManufacturer,
                                        disabled: !_ctx.isClientInstaller,
                                        "allow-empty": false
                                    }, {
                                        noResult: _withCtx(() => [...(_cache[25] || (_cache[25] = [
                                                _createTextVNode("\r\n\t\t\t\t\t\t\t\t\t\tNo results found\r\n\t\t\t\t\t\t\t\t\t", -1 /* CACHED */)
                                            ]))]),
                                        option: _withCtx((props) => [
                                            _createElementVNode("div", null, [
                                                _createElementVNode("span", null, _toDisplayString(props.option.text), 1 /* TEXT */),
                                                _cache[27] || (_cache[27] = _createTextVNode()),
                                                _createElementVNode("div", {
                                                    class: "float-end",
                                                    onClick: _withModifiers(($event) => (_ctx.deleteManufacturer(props.option)), ["stop", "prevent"])
                                                }, [...(_cache[26] || (_cache[26] = [
                                                        _createElementVNode("i", { class: "fa fa-trash" }, null, -1 /* CACHED */)
                                                    ]))], 8 /* PROPS */, _hoisted_7)
                                            ])
                                        ]),
                                        _: 1 /* STABLE */
                                    }, 8 /* PROPS */, ["modelValue", "placeholder", "options", "onTag", "disabled"]),
                                    _cache[33] || (_cache[33] = _createTextVNode()),
                                    _createVNode(_component_multiselect, {
                                        name: "modelId",
                                        modelValue: _ctx.model,
                                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((_ctx.model) = $event)),
                                        "track-by": "modelId",
                                        label: "modelName",
                                        class: "ms-2",
                                        placeholder: _ctx.selectPlaceholder,
                                        options: _ctx.stringModels,
                                        showLabels: false,
                                        allowEmpty: true,
                                        taggable: true,
                                        "tag-placeholder": "Press enter to add new model",
                                        onTag: _ctx.addStringModel,
                                        disabled: !_ctx.isClientInstaller,
                                        "allow-empty": false
                                    }, {
                                        noResult: _withCtx(() => [...(_cache[29] || (_cache[29] = [
                                                _createTextVNode("\r\n\t\t\t\t\t\t\t\t\t\tNo results found\r\n\t\t\t\t\t\t\t\t\t", -1 /* CACHED */)
                                            ]))]),
                                        option: _withCtx((props) => [
                                            _createElementVNode("div", null, [
                                                _createElementVNode("span", null, _toDisplayString(props.option.modelName), 1 /* TEXT */),
                                                _cache[31] || (_cache[31] = _createTextVNode()),
                                                _createElementVNode("div", {
                                                    class: "float-end",
                                                    onClick: _withModifiers(($event) => (_ctx.deleteControllerModel(props.option)), ["stop", "prevent"])
                                                }, [...(_cache[30] || (_cache[30] = [
                                                        _createElementVNode("i", { class: "fa fa-trash" }, null, -1 /* CACHED */)
                                                    ]))], 8 /* PROPS */, _hoisted_8)
                                            ])
                                        ]),
                                        _: 1 /* STABLE */
                                    }, 8 /* PROPS */, ["modelValue", "placeholder", "options", "onTag", "disabled"])
                                ]))
                                : _createCommentVNode("v-if", true),
                            _cache[39] || (_cache[39] = _createTextVNode()),
                            _createElementVNode("div", null, [
                                _createVNode(_component_b_button, {
                                    class: "mb-0",
                                    "variant-": "primary",
                                    onClick: _ctx.update,
                                    disabled: (_ctx.settingManufacturerAndModel && (_ctx.manufacturer == null || _ctx.model == null)) || ((_ctx.settingManufacture || _ctx.settingReplacement) && _ctx.manufactureDate == null) || (_ctx.settingReplacement && _ctx.replacementDate == null)
                                }, {
                                    default: _withCtx(() => [...(_cache[34] || (_cache[34] = [
                                            _createElementVNode("i", {
                                                class: "fa fa-save",
                                                "aria-hidden": "true"
                                            }, null, -1 /* CACHED */)
                                        ]))]),
                                    _: 1 /* STABLE */
                                }, 8 /* PROPS */, ["onClick", "disabled"]),
                                _cache[36] || (_cache[36] = _createTextVNode()),
                                _createVNode(_component_b_button, {
                                    class: "mb-0",
                                    "variant-": "seconday",
                                    onClick: _ctx.cancel
                                }, {
                                    default: _withCtx(() => [...(_cache[35] || (_cache[35] = [
                                            _createElementVNode("i", {
                                                class: "fa fa-times",
                                                "aria-hidden": "true"
                                            }, null, -1 /* CACHED */)
                                        ]))]),
                                    _: 1 /* STABLE */
                                }, 8 /* PROPS */, ["onClick"])
                            ])
                        ], 64 /* STABLE_FRAGMENT */))
                        : _createCommentVNode("v-if", true)
                ]),
                _cache[57] || (_cache[57] = _createTextVNode()),
                _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("ul", _hoisted_10, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.componentTree.children, (child, index) => {
                            return (_openBlock(), _createBlock(_component_ComponentTreeVue, {
                                key: index,
                                item: child,
                                parentId: -1,
                                "selected-nodes": _ctx.selectedComponentTreeNodes,
                                "onUpdate:selectedNodes": _cache[4] || (_cache[4] = ($event) => ((_ctx.selectedComponentTreeNodes) = $event)),
                                selectable: !_ctx.isClient
                            }, {
                                content: _withCtx(({ displayName, whenManufactured, whenLastReplacement, manufacturerName, blockTargetFloatVoltage, modelName, whenInstalled, whenNextReplacement, componentTypeId, componentId }) => [
                                    _createElementVNode("div", _hoisted_11, [
                                        _createElementVNode("div", _hoisted_12, _toDisplayString(displayName), 1 /* TEXT */),
                                        _cache[55] || (_cache[55] = _createTextVNode()),
                                        (_ctx.isString(componentTypeId))
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                                                (_ctx.isClient)
                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                                                        _cache[42] || (_cache[42] = _createElementVNode("span", { class: "fst-italic" }, "Manufacturer:", -1 /* CACHED */)),
                                                        _createTextVNode("  " + _toDisplayString(manufacturerName !== null && manufacturerName !== void 0 ? manufacturerName : '-') + " |\r\n\t\t\t\t\t\t\t\t\t\t\t", 1 /* TEXT */),
                                                        _cache[43] || (_cache[43] = _createElementVNode("span", { class: "fst-italic" }, "   Model:", -1 /* CACHED */)),
                                                        _createTextVNode("  " + _toDisplayString(modelName !== null && modelName !== void 0 ? modelName : '-') + " |\r\n\t\t\t\t\t\t\t\t\t\t\t", 1 /* TEXT */),
                                                        _cache[44] || (_cache[44] = _createElementVNode("span", { class: "fst-italic" }, "   Installed on:", -1 /* CACHED */)),
                                                        _createTextVNode("  " + _toDisplayString(_ctx.getDateFormatted(whenInstalled)) + " |\r\n\t\t\t\t\t\t\t\t\t\t\t", 1 /* TEXT */),
                                                        whenNextReplacement
                                                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                                _cache[41] || (_cache[41] = _createElementVNode("span", { class: "fst-italic" }, "   Next Replacement:", -1 /* CACHED */)),
                                                                _createTextVNode("  " + _toDisplayString(_ctx.getDateFormatted(whenNextReplacement)) + " |\r\n\t\t\t\t\t\t\t\t\t\t\t", 1 /* TEXT */)
                                                            ], 64 /* STABLE_FRAGMENT */))
                                                            : _createCommentVNode("v-if", true),
                                                        _cache[45] || (_cache[45] = _createTextVNode()),
                                                        _cache[46] || (_cache[46] = _createElementVNode("span", { class: "fst-italic" }, "   Block Target Float Value:", -1 /* CACHED */)),
                                                        _createTextVNode("  " + _toDisplayString(blockTargetFloatVoltage !== null && blockTargetFloatVoltage !== void 0 ? blockTargetFloatVoltage : '-') + " " + _toDisplayString(blockTargetFloatVoltage ? '(V)' : ''), 1 /* TEXT */)
                                                    ]))
                                                    : (_openBlock(), _createElementBlock("div", _hoisted_15, [
                                                        _createElementVNode("a", {
                                                            class: "blue",
                                                            onClick: _withModifiers(($event) => (_ctx.editString(componentId)), ["stop"])
                                                        }, [
                                                            _cache[48] || (_cache[48] = _createElementVNode("span", { class: "fst-italic" }, "Manufacturer:", -1 /* CACHED */)),
                                                            _createTextVNode("  " + _toDisplayString(manufacturerName !== null && manufacturerName !== void 0 ? manufacturerName : '-') + " |\r\n\t\t\t\t\t\t\t\t\t\t\t\t", 1 /* TEXT */),
                                                            _cache[49] || (_cache[49] = _createElementVNode("span", { class: "fst-italic" }, "   Model:", -1 /* CACHED */)),
                                                            _createTextVNode("  " + _toDisplayString(modelName !== null && modelName !== void 0 ? modelName : '-') + " |\r\n\t\t\t\t\t\t\t\t\t\t\t\t", 1 /* TEXT */),
                                                            _cache[50] || (_cache[50] = _createElementVNode("span", { class: "fst-italic" }, "   Installed on:", -1 /* CACHED */)),
                                                            _createTextVNode("  " + _toDisplayString(_ctx.getDateFormatted(whenInstalled)) + " |\r\n\t\t\t\t\t\t\t\t\t\t\t\t", 1 /* TEXT */),
                                                            whenNextReplacement
                                                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                                    _cache[47] || (_cache[47] = _createElementVNode("span", { class: "fst-italic" }, "   Next Replacement:", -1 /* CACHED */)),
                                                                    _createTextVNode("  " + _toDisplayString(_ctx.getDateFormatted(whenNextReplacement)) + " |\r\n\t\t\t\t\t\t\t\t\t\t\t\t", 1 /* TEXT */)
                                                                ], 64 /* STABLE_FRAGMENT */))
                                                                : _createCommentVNode("v-if", true),
                                                            _cache[51] || (_cache[51] = _createTextVNode()),
                                                            _cache[52] || (_cache[52] = _createElementVNode("span", { class: "fst-italic" }, "   Block Target Float Value:", -1 /* CACHED */)),
                                                            _createTextVNode("  " + _toDisplayString(blockTargetFloatVoltage !== null && blockTargetFloatVoltage !== void 0 ? blockTargetFloatVoltage : '-') + " " + _toDisplayString(blockTargetFloatVoltage ? '(V)' : ''), 1 /* TEXT */)
                                                        ], 8 /* PROPS */, _hoisted_16)
                                                    ]))
                                            ]))
                                            : _createCommentVNode("v-if", true),
                                        _cache[56] || (_cache[56] = _createTextVNode()),
                                        (_ctx.isBlock(componentTypeId))
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                                                _cache[54] || (_cache[54] = _createElementVNode("span", { class: "fst-italic" }, "Manufactured on:", -1 /* CACHED */)),
                                                _createTextVNode("  " + _toDisplayString(_ctx.getDateFormatted(whenManufactured)) + " ", 1 /* TEXT */),
                                                whenLastReplacement
                                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                        _cache[53] || (_cache[53] = _createElementVNode("span", { class: "fst-italic" }, "   Replaced on:", -1 /* CACHED */)),
                                                        _createTextVNode("  " + _toDisplayString(_ctx.getDateFormatted(whenLastReplacement)), 1 /* TEXT */)
                                                    ], 64 /* STABLE_FRAGMENT */))
                                                    : _createCommentVNode("v-if", true)
                                            ]))
                                            : _createCommentVNode("v-if", true)
                                    ])
                                ]),
                                _: 1 /* STABLE */
                            }, 8 /* PROPS */, ["item", "selected-nodes", "selectable"]));
                        }), 128 /* KEYED_FRAGMENT */))
                    ])
                ])
            ])
        ], 512 /* NEED_PATCH */), [
            [_vShow, _ctx.loaded]
        ]),
        _cache[91] || (_cache[91] = _createTextVNode()),
        _createVNode(_component_b_modal, {
            id: "string_popup",
            modelValue: _ctx.editingString,
            "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event) => ((_ctx.editingString) = $event)),
            "header-bg-variant": "normal",
            size: "md"
        }, {
            title: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.selectedString.displayName), 1 /* TEXT */)
            ]),
            footer: _withCtx(() => [
                _createElementVNode("div", _hoisted_27, [
                    _createVNode(_component_b_button, {
                        type: "button",
                        variant: "primary",
                        onClick: _ctx.saveString,
                        disabled: !_ctx.isClientInstaller
                    }, {
                        default: _withCtx(() => [...(_cache[86] || (_cache[86] = [
                                _createElementVNode("i", { class: "fa fa-save" }, null, -1 /* CACHED */),
                                _createTextVNode(" Save\r\n\t\t\t\t\t", -1 /* CACHED */)
                            ]))]),
                        _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["onClick", "disabled"]),
                    _cache[88] || (_cache[88] = _createTextVNode()),
                    _createVNode(_component_b_button, {
                        type: "button",
                        variant: "secondary",
                        onClick: _ctx.closeString
                    }, {
                        default: _withCtx(() => [...(_cache[87] || (_cache[87] = [
                                _createElementVNode("i", { class: "fa fa-times" }, null, -1 /* CACHED */),
                                _createTextVNode(" Close\r\n\t\t\t\t\t", -1 /* CACHED */)
                            ]))]),
                        _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["onClick"])
                ])
            ]),
            default: _withCtx(() => [
                _cache[89] || (_cache[89] = _createTextVNode()),
                _createVNode(_component_b_container, { clearfix: "" }, {
                    default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_18, [
                            _createElementVNode("div", _hoisted_19, [
                                _cache[62] || (_cache[62] = _createElementVNode("label", null, "\r\n\t\t\t\t\t\t\tManufacturer\r\n\t\t\t\t\t\t", -1 /* CACHED */)),
                                _cache[63] || (_cache[63] = _createTextVNode()),
                                _createVNode(_component_multiselect, {
                                    name: "stringManufacturerId",
                                    modelValue: _ctx.stringManufacturer,
                                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => ((_ctx.stringManufacturer) = $event)),
                                    "track-by": "value",
                                    label: "text",
                                    placeholder: _ctx.selectPlaceholder,
                                    options: _ctx.batteryManufacturers,
                                    showLabels: false,
                                    allowEmpty: true,
                                    taggable: true,
                                    "tag-placeholder": "Press enter to add new manufacturer",
                                    onTag: _ctx.addStringManufacturer,
                                    disabled: !_ctx.isClientInstaller
                                }, {
                                    noResult: _withCtx(() => [...(_cache[58] || (_cache[58] = [
                                            _createTextVNode("\r\n\t\t\t\t\t\t\t\tNo results found\r\n\t\t\t\t\t\t\t", -1 /* CACHED */)
                                        ]))]),
                                    option: _withCtx((props) => [
                                        _createElementVNode("div", null, [
                                            _createElementVNode("span", null, _toDisplayString(props.option.text), 1 /* TEXT */),
                                            _cache[60] || (_cache[60] = _createTextVNode()),
                                            _createElementVNode("div", {
                                                class: "float-end",
                                                onClick: _withModifiers(($event) => (_ctx.deleteManufacturer(props.option)), ["stop", "prevent"])
                                            }, [...(_cache[59] || (_cache[59] = [
                                                    _createElementVNode("i", { class: "fa fa-trash" }, null, -1 /* CACHED */)
                                                ]))], 8 /* PROPS */, _hoisted_20)
                                        ])
                                    ]),
                                    _: 1 /* STABLE */
                                }, 8 /* PROPS */, ["modelValue", "placeholder", "options", "onTag", "disabled"])
                            ]),
                            _cache[82] || (_cache[82] = _createTextVNode()),
                            _createElementVNode("div", _hoisted_21, [
                                _cache[68] || (_cache[68] = _createElementVNode("label", null, "\r\n\t\t\t\t\t\t\tModel\r\n\t\t\t\t\t\t", -1 /* CACHED */)),
                                _cache[69] || (_cache[69] = _createTextVNode()),
                                _createVNode(_component_multiselect, {
                                    name: "stringModelId",
                                    modelValue: _ctx.stringModel,
                                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event) => ((_ctx.stringModel) = $event)),
                                    "track-by": "modelId",
                                    label: "modelName",
                                    placeholder: _ctx.selectPlaceholder,
                                    options: _ctx.stringModels,
                                    showLabels: false,
                                    allowEmpty: true,
                                    taggable: true,
                                    "tag-placeholder": "Press enter to add new model",
                                    onTag: _ctx.addStringModel,
                                    disabled: !_ctx.isClientInstaller
                                }, {
                                    noResult: _withCtx(() => [...(_cache[64] || (_cache[64] = [
                                            _createTextVNode("\r\n\t\t\t\t\t\t\t\tNo results found\r\n\t\t\t\t\t\t\t", -1 /* CACHED */)
                                        ]))]),
                                    option: _withCtx((props) => [
                                        _createElementVNode("div", null, [
                                            _createElementVNode("span", null, _toDisplayString(props.option.modelName), 1 /* TEXT */),
                                            _cache[66] || (_cache[66] = _createTextVNode()),
                                            _createElementVNode("div", {
                                                class: "float-end",
                                                onClick: _withModifiers(($event) => (_ctx.deleteControllerModel(props.option)), ["stop", "prevent"])
                                            }, [...(_cache[65] || (_cache[65] = [
                                                    _createElementVNode("i", { class: "fa fa-trash" }, null, -1 /* CACHED */)
                                                ]))], 8 /* PROPS */, _hoisted_22)
                                        ])
                                    ]),
                                    _: 1 /* STABLE */
                                }, 8 /* PROPS */, ["modelValue", "placeholder", "options", "onTag", "disabled"])
                            ]),
                            _cache[83] || (_cache[83] = _createTextVNode()),
                            (_ctx.selectedString.whenInstalled !== undefined)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                                    _cache[72] || (_cache[72] = _createElementVNode("label", null, "\r\n\t\t\t\t\t\t\tInstalled On\r\n\t\t\t\t\t\t", -1 /* CACHED */)),
                                    _cache[73] || (_cache[73] = _createTextVNode()),
                                    _createVNode(_component_b_input_group, { class: "clearfix bottom0" }, {
                                        default: _withCtx(() => [
                                            _createVNode(_component_flat_pickr, {
                                                modelValue: _ctx.whenInstalled,
                                                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event) => ((_ctx.whenInstalled) = $event)),
                                                class: "form-control",
                                                config: _ctx.datePickerConfig,
                                                disabled: !_ctx.isClientInstaller
                                            }, null, 8 /* PROPS */, ["modelValue", "config", "disabled"]),
                                            _cache[71] || (_cache[71] = _createTextVNode()),
                                            _createVNode(_component_b_input_group_append, null, {
                                                default: _withCtx(() => [
                                                    _createVNode(_component_b_button, {
                                                        type: "button",
                                                        variant: "outline-secondary",
                                                        "data-toggle": ""
                                                    }, {
                                                        default: _withCtx(() => [...(_cache[70] || (_cache[70] = [
                                                                _createElementVNode("i", { class: "fa fa-calendar" }, null, -1 /* CACHED */)
                                                            ]))]),
                                                        _: 1 /* STABLE */
                                                    })
                                                ]),
                                                _: 1 /* STABLE */
                                            })
                                        ]),
                                        _: 1 /* STABLE */
                                    })
                                ]))
                                : _createCommentVNode("v-if", true),
                            _cache[84] || (_cache[84] = _createTextVNode()),
                            (_ctx.selectedString.whenNextReplacement !== undefined)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                                    _cache[76] || (_cache[76] = _createElementVNode("label", null, "\r\n\t\t\t\t\t\t\tWhen Next Replacement\r\n\t\t\t\t\t\t", -1 /* CACHED */)),
                                    _cache[77] || (_cache[77] = _createTextVNode()),
                                    _createVNode(_component_b_input_group, { class: "clearfix bottom0" }, {
                                        default: _withCtx(() => [
                                            _createVNode(_component_flat_pickr, {
                                                modelValue: _ctx.whenNextReplacement,
                                                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event) => ((_ctx.whenNextReplacement) = $event)),
                                                class: "form-control",
                                                config: _ctx.datePickerConfig,
                                                disabled: !_ctx.isClientInstaller
                                            }, null, 8 /* PROPS */, ["modelValue", "config", "disabled"]),
                                            _cache[75] || (_cache[75] = _createTextVNode()),
                                            _createVNode(_component_b_input_group_append, null, {
                                                default: _withCtx(() => [
                                                    _createVNode(_component_b_button, {
                                                        type: "button",
                                                        variant: "outline-secondary",
                                                        "data-toggle": ""
                                                    }, {
                                                        default: _withCtx(() => [...(_cache[74] || (_cache[74] = [
                                                                _createElementVNode("i", { class: "fa fa-calendar" }, null, -1 /* CACHED */)
                                                            ]))]),
                                                        _: 1 /* STABLE */
                                                    })
                                                ]),
                                                _: 1 /* STABLE */
                                            })
                                        ]),
                                        _: 1 /* STABLE */
                                    })
                                ]))
                                : _createCommentVNode("v-if", true),
                            _cache[85] || (_cache[85] = _createTextVNode()),
                            _createElementVNode("div", _hoisted_25, [
                                _cache[79] || (_cache[79] = _createElementVNode("label", null, "\r\n\t\t\t\t\t\t\tBlock Target Float Voltage (V)\r\n\t\t\t\t\t\t", -1 /* CACHED */)),
                                _cache[80] || (_cache[80] = _createTextVNode()),
                                _createVNode(_component_b_form_input, {
                                    type: "number",
                                    modelValue: _ctx.selectedString.blockTargetFloatVoltage,
                                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event) => ((_ctx.selectedString.blockTargetFloatVoltage) = $event)),
                                    modelModifiers: { trim: true },
                                    min: "0",
                                    max: "1000",
                                    step: "0.1"
                                }, null, 8 /* PROPS */, ["modelValue"]),
                                _cache[81] || (_cache[81] = _createTextVNode()),
                                _createElementVNode("div", _hoisted_26, [
                                    _createVNode(_component_b_form_checkbox, {
                                        modelValue: _ctx.replicateBlockTargetFloatVoltage,
                                        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event) => ((_ctx.replicateBlockTargetFloatVoltage) = $event)),
                                        size: "lg"
                                    }, {
                                        default: _withCtx(() => [...(_cache[78] || (_cache[78] = [
                                                _createTextVNode("\r\n\t\t\t\t\t\t\t\tReplicate this value for other Strings\r\n\t\t\t\t\t\t\t", -1 /* CACHED */)
                                            ]))]),
                                        _: 1 /* STABLE */
                                    }, 8 /* PROPS */, ["modelValue"])
                                ])
                            ])
                        ])
                    ]),
                    _: 1 /* STABLE */
                }),
                _cache[90] || (_cache[90] = _createTextVNode())
            ]),
            _: 1 /* STABLE */
        }, 8 /* PROPS */, ["modelValue"])
    ]));
}
